import React from "react";
import { useState } from "react";
import { DND_LINK } from "../../../utils/constants";
//import NotesFacilitatorViewModal from "./NotesFacilitatorViewModal";
import NotesServiceFacilitatorModal from "./NotesServiceFacilitatorModel";
//import ./UserFacilitatorFeedbackModal 
//import UserFacilitatorFeedbackModal from "./UserFacilitatorFeedbackModal";
import NotesServiceFacilitatorViewModal from "./NotesServiceFacilitatorViewModel";
import NotesToolsTemplatesModel from "./NotesToolsTempaltesModel";
//import NotesModal from "./NotesModal";
import ServiceStatusModal from "./ServiceStatusModal";
import ReactTable from "react-table";
import Select from "react-select";
import MultiSelectAll from "../../../common/Multiselect/MultiSelectAll";
import ic_filter from "./../../../assets/ic_filter.svg";
 //import { Button } from "../../../common/Button/Button";
//import { getServiceTypesMaster } from "../../../utils/localStorage";
//import find from "lodash/find";
//import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../../common/Pagination/Pagination";
import { getServiceTypesMaster } from "../../../utils/localStorage";
import find from "lodash/find";
import moment from "moment";
import { Button } from "../../../common/Button/Button";
import Checkbox from "../../../common/Checkbox/Checkbox";
import copysvg from "./../../../assets/arrow_copy.svg";
//import ColumnSelectionDropdown from "./ColumnSelectionDropdown";
import arrow_right from "../../../assets/ic_header_arrow_right.svg";
import arrow_left from "../../../assets/ic_header_arrow_left.svg";
import arrow_more from "../../../assets/ic_more.svg";
import { toast } from "react-toastify";
import ColumnSectionDropdown from "../Admin/ColumnSelectionDropdown";
import CancellationReasonModal from "../Handholder/CancellationReasonModal";
//import { color } from "html2canvas/dist/types/css/types/color";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

//import moment from "moment";

export default function FacilitatorToolsTable(props)
{


	const [columnPage,setcolumnPage] =useState(0);
	const [selectedColumnsCount,setSelectedColumnCount] =useState(0);



	const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};


    const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};

	const NoDataComponent = (p) => {
		return <div>No data</div>;
	};

	// const generateColumns=()=>{

	// 	let selectedColumnCount =0;
	// 	let currentCount =0;
	// 	let colPage=columnPage;

	// const toggleConfirmationModal = () => {
	// 	setShowConfirmationModal(!showConfirmationModal);
	// };


	// const [selectednResourceInstanceIdForConfirmation, setselectednResourceInstanceIdForConfirmation] = useState(null);
	// const toggleConfirmationModal = (nResourceInstasnceId) => {
	// 	setselectednResourceInstanceIdForConfirmation(nResourceInstasnceId);
	// 	setShowConfirmationModal(!showConfirmationModal);
	// };





	// const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	// const [selectedStatus, setSelectedStatus] = useState({});
	// const handleClick = () => {
	// 	if (props.selectedOptions !== undefined) {
	// 		if (props.selectedOptions === "Cancelled") {
	// 			props.toggleCancellationReasonModal();
	// 			setSelectedStatus({ selectedOptions: props.SearchStatusByOptions});
	// 		} else {
	// 			toggleConfirmationModal();
	// 			// toggleStatusChangeModal();
	// 			setSelectedStatus({ selectedOptions: props.SearchStatusByOptions});
	// 		}
	// 	}
	// };


	// const changeState = () => {
	// 	props.changeState(selectedStatus);
	// 	if (selectedStatus.props.selectedOptions !== "Cancelled")
	// 		toggleConfirmationModal();
	// };


	
     const columns = [
		{
			id: "sResourceDisplayName",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
			style: { 'whiteSpace': 'unset'},
			Header: "Service + Offering Details",
			accessor: "sResourceDisplayName",
			//width: 300,
			//height:10,
			Cell:({original})=>(
				<>
					<span>
						  
					<span>{original.refService.sResourceDisplayName}</span>
                        <br></br> 
                        <br></br>
                        <span>ID: {original.refService.nResourceInstanceId}</span>
					</span><br></br>
					{/* <span>
						{`Service ID : ${original.refService.nResourceInstanceId}`}
					</span> */}
					<br></br><br></br>
					 
						 
					{
						original.refService.sOfferingName||original.refService.sOfferingID?
						(
							<>
								<span>
								{
								original.refService.sOfferingName ? 
								original.refService.sOfferingName :
								""
								}
								</span><br></br>
								<span>
								{`Offering ID : ${original.refService.sOfferingID}`}
								</span>
							</>
						)
						:("")
					}	
					 
					 
				</>
			)
		},

		 

		{
			id: "customerDetails",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
			style: { 'whiteSpace': 'unset'},
			Header: "Customer Details",
			accessor: "customerDetails",
			//width: 300,
			//height:10,
			Cell:({original})=>
			{
			return original["refService"]?(
				<>
					<div className={"conv-float-left"}>
							<div>
								<span className="conv-float-left conv-mr18 lpm-service-grid-key"></span>
								{
									original.refService.sEmailId?
									(
										
										<>
										    <span className="conv-ml10 ">
											{original["refService"]["sFirstName"]}{" "}
											{original["refService"]["sLastName"]}
										    </span>
											<br></br>
											<br></br>
										
											<img
												alt="copy"
												src={copysvg}
												height={"20px"}
												width={"16px"}
												className="con-cursor-pointer conv-mr13 conv-ml10"
												onClick={(e) => {
													e.preventDefault();
													copyToClipboard(original.refService.sEmailId);
													toast(`${
														original.refService.sFirstName ? 
														original.refService.sFirstName :
														""
													}${' '}
													${
														original.refService.sLastName ? 
														original.refService.sLastName :
														""
													}'s Email Copied!`, {
														autoClose: 5000,
														type: toast.TYPE.SUCCESS,
													});
												}}
											/>
											<span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"169px"}}>
												
												{
													original.refService.sEmailId
												}
											</span><br></br>
											
										</>
										
									)
									:
									("NA")
								}
							</div>
							<div style={{"clear":"both"}}></div>
							<div className="conv-mt10">
							<span className="conv-float-left conv-mr5 lpm-service-grid-key"></span>
								{
									original.refService.sContactNumber?
									(
										<>
										
										
											<img
												alt="copy"
												src={copysvg}
												height={"20px"}
												width={"16px"}
												className="con-cursor-pointer conv-mr13 conv-ml10"
												onClick={(e) => {
													e.preventDefault();
													copyToClipboard(original.refService.sContactNumber);
													toast(`${
														original.refService.sFirstName ? 
														original.refService.sFirstName :
														""
													}${' '}
													${
														original.refService.sLastName ? 
														original.refService.sLastName :
														""
													}'s Contact Copied!`, {
														autoClose: 5000,
														type: toast.TYPE.SUCCESS,
													});
												}}
											/>
											<span className="lpm-service-grid-value" style={{wordBreak:"break-all",float:"right",width:"169px"}}>										
												{
													original.refService.sContactNumber
												}
											</span>
											<br></br>
											{/* <span className="conv-ml55">
											{original["refService"]["sFirstName"]}{" "}
											{original["refService"]["sLastName"]}
										    </span> */}
										</>
									)
									:
									("")
								}
							</div>
						</div>
				</>
			) :(<span>
				""
			</span>)
			},
							 
		},

		{
			id: "dtFollowupOn",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
			style: { 'whiteSpace': 'unset'},
			Header: "Follow Up Details",
			accessor: "dtFollowupOn",
			//width: 300,
			Cell: ({ original }) => {
                return original["dtFollowupOn"] ? (
					
                    <span>
						{original["refCreatedBy"]["email"]}
						<br></br>
                        {moment(
                            moment.utc(original["dtFollowupOn"]).toDate()
                        ).format("Do MMMM YYYY")}
                    </span>	 
                ) : (
                    <span>-</span>
                );
            },

		},


		 

		{
				id: "refUpdatedBy",
				headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
				style: { 'whiteSpace': 'unset'},
				Header: "Update Details",
				accessor: "refUpdatedBy",
				//width: 280,
				Cell: ({ original }) => {
					return original["refUpdatedBy"] ? (
						<span>{original["refUpdatedBy"]["email"]}
						<br></br>
						{moment(
                            moment.utc(original["refUpdatedBy"]).toDate()
                        ).format("Do MMMM YYYY")}
						</span>	
					) : (
						<span>{"-"}</span>	
					);
					
				},
			},

		{
			id: " ",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc','width':'20%'},
			style: { 'whiteSpace': 'unset'},
			Header: "Action Items",
			accessor: "",
			//width: 255,
			//className:"conv-line-height",
			Cell:({ original }) => {
                return original["refService"] ? (
					
                    <span className="conv-line-height">

						<a 
							style={{ textDecoration: "underline" }}
							onClick={() => {
								props.onSelectFacilitatorAction(original);
							    props.toggleNotesModal();
							}}
						>
							<span className="label-link">Notes</span>
						</a>

						 
					<br></br>

					{/* {
							original.refService.refCurrentState&&original.refService.refCurrentState.sServiceState=="Delivered"?
							(
								<>
									 <a className={`label-link ${original.refService.refCurrentState&&original.refService.refCurrentState.sServiceState!="Delivered"?"disable":""}`}  href="javascript:void(0);" onClick={(e) => props.toggleShowFeedbackModal(e, original)} target="_self" className="label-link">
									{"Feedback"}
									</a>
								</>								
							):

							// original.refService.refCurrentState&&original.refService.refCurrentState.sServiceState!="Delivered"?

							
							(
								<>
									<a className={`label-link ${original.refService.refCurrentState&&original.refService.refCurrentState.sServiceState!="Delivered"?"disable":""}`} href="javascript:void(0);" onClick={(e) => props.toggleShowFeedbackModal(e, original)} target="_self">
									{"Feedback"}

									</a>
								</>			
								//"Feedback"
							)
							 
						} */}
                        <span className="label-link conv-line-height">Feedback</span>
                     
					<br></br>
						<a href="/home/three-sixty-degree-view-new/"target="_blank" className="label-link conv-line-height">	 
						360 Degree View
					    </a>        
						<br></br>
						<a href="https://www.deasra.in/dnd-user/"target="_blank" className="label-link conv-line-height">	 
						DND Update Link
					    </a>          
						 {/* <a href={DND_LINK} target="_blank">
            				DND Update Link
            			</a> */}
                    </span>	 
                ) : (
                    <span>-</span>
                );
            },
		},

	 ];
	
	
// }

    return (
		<>
		<div className="col-12 conv-mt25 conv-pl40 conv-pr40 spled-container fix-filter">
			<div className="spled-container">
				<div className={`service-partner spled-container`}>
				<ReactTableFixedColumns
							minRows={0}
							data={props.data || []}
							columns={columns}
							manual
							defaultPage={props.page}
							pages={props.pages}
							page={props.page}
							pageSize={props.pageSize}
							sortable={false}
							defaultPageSize={10}
							showPagination={true}
							pageSizeOptions={[10]}
							onFetchData={(state, instance) => {
								props.onFetchServiceRequests(instance, false);
							}}
							onPageSizeChange={props.onPageSizeOptionChange}
							PaginationComponent={Pagination}
							style={{overflowY: "initial",height: "445px"}}			
							className="-striped hide-scrollbar"
                		/>
						<NotesToolsTemplatesModel
							// auditTrail={props.auditTrail}  
							// changeSelectedNotesDetails={props.changeSelectedNotesDetails}  
							// notesHistory={props.notesHistory}  
						facilitatorActionView={props.facilitatorActionView}
						notesDetails={props.selectedFacilitatorAction}
						isOpen={props.showNotesModal}
						toggleModal={props.toggleNotesModal}
						onInputChange={props.onNotesChange}
						onSaveNotesDetails={props.onSaveSelectedFacilitatorAction}
						isOpenConfirmationModal={props.showConfirmationModalNotes}
						toggleConfirmationModal={props.toggleConfirmationModalNotes}
						confirmChangeNotes={props.confirmChangeNotes}
						//nResourceInstanceId={selectednResourceInstanceIdForNotes}
						/>

								{/* <NotesServiceFacilitatorModal
									facilitatorActionView={props.facilitatorActionView}
                                    auditTrail={props.auditTrail}
                                    changeSelectedNotesDetails={props.changeSelectedNotesDetails}
                                    notesHistory={props.notesHistory}
                                    notesDetails={props.notesDetails}
                                    isOpen={props.showNotesModal}
                                    toggleModal={props.toggleNotesModal}
                                    onInputChange={props.onNotesChange}
                                    onSaveNotesDetails={props.onSaveNotesDetails}
                                    isOpenConfirmationModal={props.showConfirmationModalNotes}
                                    toggleConfirmationModal={props.toggleConfirmationModalNotes}
                                    confirmChangeNotes={props.confirmChangeNotes}
                                      
									

                                    needToTalkToSPOptions={props.needToTalkToSPOptions}
                                    selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
                                    setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
                                    service={props.selectedServiceRequest}
                                    onUpdateNeedToTalkToSPFlag={props.onUpdateNeedToTalkToSPFlag}
                                     
                                /> */}
								
								{/* <NotesServiceFacilitatorViewModal
							// auditTrail={props.auditTrail}  
							// changeSelectedNotesDetails={props.changeSelectedNotesDetails}  
							// notesHistory={props.notesHistory}  
							facilitatorActionView={props.facilitatorActionView}
							notesDetails={props.selectedFacilitatorAction}
							isOpen={props.showNotesModal}
							toggleModal={props.toggleNotesModal}
							onInputChange={props.onNotesChange}
							onSaveNotesDetails={props.onSaveSelectedFacilitatorAction}
							isOpenConfirmationModal={props.showConfirmationModalNotes}
							toggleConfirmationModal={props.toggleConfirmationModalNotes}
							confirmChangeNotes={props.confirmChangeNotes}
							/> */}
							
							<ServiceStatusModal
							onservicestatusclick ={props.onservicestatusclick }
							isOpen={props.showServiceStatusModal}
							toggleModal={props.toggleServiceStatusModal}							
							SearchsByDropdownLists={props.SearchsByDropdownLists}				
							isSearchByStatusDropdownOpen={props.isSearchByStatusDropdownOpen}
							togglesSearchsByVisibilitys={props.togglesSearchsByVisibilitys}
							//SearchDropdownRef={SearchDropdownRef}
							SearchsDropdownRefs={props.SearchsDropdownRefs}
							//selectSearchBySelection={selectSearchBySelection}
							selectSearchStatusBySelection={props.selectSearchStatusBySelection}
							selectedOptions={props.selectedOptions}
							onStatusOptionChange={props.onStatusOptionChange}
							changeState={props.changeState}
							// toggleConfirmationModal={toggleConfirmationModal}
							// handleClick={handleClick}
							// selectednResourceInstanceIdForConfirmation={selectednResourceInstanceIdForConfirmation}
							toggleCancellationReasonModal={
								props.toggleCancellationReasonModal
							}

							cancellationReasonDropdownOptions={
								props.cancellationReasonDropdownOptions
								}
								onSelectCancellationReason={props.setSelectedCancellationReason}
								selectedCancellationReason={props.selectedCancellationReason}
								enableOtherDescriptionTextbox={
								props.enableOtherDescriptionTextbox
								}
								cancellationReasonOtherDescription={
								props.cancellationReasonOtherDescription
								}
								onChangeCancellationReasonOtherDescription={
								props.onChangeCancellationReasonOtherDescription
								}
								selectedServiceRequestForStatusProgression={props.selectedServiceRequestForStatusProgression}
							// toggleAll={toggleAllForServiceStatusFilter}
							// toggleSelection={toggleSelectionForServiceStatusFilter}
							// checkboxItemsList={serviceStatusNameListForFilter}
							// selectedOptions={selectedServiceStatusListForFilter}
							// placeholderButtonLabel ={"Select Status"}	
							>
							</ServiceStatusModal>

							{/* <CancellationReasonModal
							isDisabled={props.enableCancelButtonFlag}
							isOpen={props.showCancellationReasonModal}
							toggleModal={props.toggleCancellationReasonModal}
							cancellationReasonDropdownOptions={
							props.cancellationReasonDropdownOptions
							}
							onSelectCancellationReason={props.setSelectedCancellationReason}
							selectedCancellationReason={props.selectedCancellationReason}
							enableOtherDescriptionTextbox={
							props.enableOtherDescriptionTextbox
							}
							cancellationReasonOtherDescription={
							props.cancellationReasonOtherDescription
							}
							onChangeCancellationReasonOtherDescription={
							props.onChangeCancellationReasonOtherDescription
							}
							onChangeState={changeState}
							></CancellationReasonModal> */}

						
				</div>
			</div>
		</div>
			
		</>
	);
}